import gql from 'graphql-tag';

export default gql`
  fragment ItineraryAncillaryOrderItemFragment on OrderItem {
    ... on ItineraryAncillaryOrderItem {
      id
      flightId
      travelerId
      ancillaryType
      quantity
      price {
        amount
        currency
      }
      bundledAncillaryPrice {
        amount
      }
      isBundledAncillaryIncluded
      code
    }
  }
`;
